const styles = ({ spacing }) => ({
  '& p:last-child, & li:last-child': {
    margin: 0,
    padding: 0,
  },
  '& ul': {
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
  padding: [spacing.sm, spacing.xs + spacing.unit],
});

export default styles;
